import { render, staticRenderFns } from "./MemberInfo.vue?vue&type=template&id=214b5483&scoped=true"
import script from "./MemberInfo.vue?vue&type=script&lang=js"
export * from "./MemberInfo.vue?vue&type=script&lang=js"
import style0 from "./MemberInfo.vue?vue&type=style&index=0&id=214b5483&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214b5483",
  null
  
)

export default component.exports